const hasPermission = (permission) => {
  const user = JSON.parse(localStorage.getItem('me'));
  const { permissions } = user.role_permissions;
  const can = permissions.some(({ name }) => name === permission);
  return !permission || can;
};

export default hasPermission;
